module.exports = __webpack_public_path__ + "img/LatenBannerMobile.16a4a509.jpg";